import React, {useEffect} from 'react'
import {Helmet} from 'react-helmet-async'
import {useNavigate} from 'react-router-dom'
import sampleTheme from '../../../common/sample-formats/themes/sample-theme.json'
import {Button} from '../../../components/library/buttons/button'
import {Icon} from '../../../components/library/icon/icon'
import {useAddThemeMutation} from '../../../data/workbench-api/generated/theme'
import {
  PermissionAction,
  PermissionResource
} from '../../../data/workbench-api/generated/types'
import {EnvironmentNode} from '../../../environment'
import {useAnalytics} from '../../../lib/analytics/analytics'
import {IconHeading, Section, SectionContent, SectionInfo} from '../components'
import {List} from './list'

export const ContainerThemes = ({
  environment
}: {
  environment: EnvironmentNode
}) => {
  const canEdit = environment.hasPermission(
    PermissionResource.Theme,
    PermissionAction.Edit
  )
  const analytics = useAnalytics()

  const [addMutation] = useAddThemeMutation({
    variables: {
      environmentId: environment.id,
      name: 'Untitled theme',
      payload: sampleTheme
    },
    refetchQueries: ['ThemeList'],
    onCompleted: () => {
      analytics.track({
        event: 'Added configuration',
        properties: {
          org_id: environment.organisationId,
          environment_id: environment.id,
          category: 'configuration>sdk>container-themes'
        }
      })
    }
  })

  const navigate = useNavigate()

  useEffect(() => {
    analytics.track({
      event: 'Viewed container themes configuration',
      properties: {
        org_id: environment.organisationId,
        environment_id: environment.id,
        category: 'configuration>sdk>container-themes'
      }
    })
  }, [analytics, environment])

  return (
    <Section>
      <Helmet>
        <title>Themes</title>
      </Helmet>
      <header>
        <IconHeading>
          <Icon name="theme" /> Themes
        </IconHeading>

        <nav>
          <Button
            onClick={() =>
              addMutation().then(result =>
                navigate(`../../themes/${result.data?.createTheme?.theme?.id}`)
              )
            }
            disabled={!canEdit}
          >
            Add theme
          </Button>
        </nav>
      </header>

      <SectionInfo>
        <p>Define stream, card and subview styles for a specific container</p>
      </SectionInfo>

      <SectionContent>
        <List environment={environment} />
      </SectionContent>
    </Section>
  )
}
